import { DialogTitle, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonClose from '../../ButtonClose/ButtonClose';

import { InfoChart } from './InfoChart/InfoChart';

interface TabPanelProps {
	children?: React.ReactNode;
	index: string;
	value: string;
}

export const TabPanel: React.FC<TabPanelProps> = ({
	children,
	value,
	index,
	...other
}) => (
	<div
		role="tabpanel"
		hidden={value !== index}
		id={`simple-tabpanel-${index}`}
		aria-labelledby={`simple-tab-${index}`}
		{...other}
	>
		{value === index && children}
	</div>
);

const useQuickMenuStyles = makeStyles((theme: Theme) => ({
	dialogTitle: {
		padding: theme.spacing(2, 4, 2),
		backgroundColor: theme.palette.grey[100],
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(4, 6, 2),
		},
	},
}));

export const InfoDialogContent: React.FC<{ handleClose(): void }> = ({
	handleClose,
}) => {
	const classes = useQuickMenuStyles();
	const { t } = useTranslation();

	return (
		<>
			<DialogTitle
				id="quick-menu-dialog"
				disableTypography={true}
				className={classes.dialogTitle}
			>
				<Typography variant="h2">{t('quickMenu.info.chart.title')}</Typography>
			</DialogTitle>
			<InfoChart showTitle={false} />
			<ButtonClose onClick={handleClose} />
		</>
	);
};
